import { createStore } from './createStore.js';

/**
 * The working "lineup" — up to 6 slots analysed by the Team view (coverage
 * / compare / calc). A slot is `{ id, form }` where `id` is the national
 * dex id and `form` is a snapshot form slug (Mega, regional, alt forme) or
 * null for the base Pokémon. Persisted; old saves stored bare ids and are
 * migrated on read.
 */
export const team = createStore('pdx.team', { members: [] });

export const MAX_TEAM = 6;

/** Normalise a stored member (number | {id,form}) to {id, form}. */
export function slot(m) {
  return typeof m === 'number' ? { id: m, form: null } : { id: m.id, form: m.form || null };
}
const sameSlot = (a, b) => a.id === b.id && (a.form || null) === (b.form || null);

export function members() {
  return team.get().members.map(slot);
}

export function addToTeam(id, form = null) {
  team.set((s) => {
    const list = s.members.map(slot);
    if (list.length >= MAX_TEAM || list.some((m) => sameSlot(m, { id, form }))) return s;
    return { ...s, members: [...list, { id, form: form || null }] };
  });
}

export function removeFromTeam(id, form = null) {
  team.set((s) => ({
    ...s,
    members: s.members.map(slot).filter((m) => !sameSlot(m, { id, form: form || null })),
  }));
}

export function clearTeam() {
  team.set({ members: [] });
}

export function inTeam(id, form = null) {
  return team
    .get()
    .members.map(slot)
    .some((m) => sameSlot(m, { id, form: form || null }));
}
